var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components-layout fsszhylfzjc pd0"},[_c('div',{staticClass:"title"},[_vm._v("佛山市智慧养老发展进程")]),_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":_vm.picture}})])])}
var staticRenderFns = []

export { render, staticRenderFns }